import React from "react";
import PropTypes from "prop-types";
import { INDUCTION_MESSAGE_STATUS } from "./constants";

const InductionMessage = ({ status, name, count = 0 }) => {
  let suffix;
  switch (status) {
    case INDUCTION_MESSAGE_STATUS.SEND:
      return (
        <div style={{ marginBottom: "20px" }}>
          Are you sure you want to send the induction form to{" "}
          <strong>{name}</strong>?
        </div>
      );
    case INDUCTION_MESSAGE_STATUS.RESEND:
      return (
        <div style={{ marginBottom: "20px" }}>
          Are you sure you want to resend the induction form to{" "}
          <strong>{name}</strong>?
        </div>
      );
    case INDUCTION_MESSAGE_STATUS.BULK:
      suffix = count !== 1 ? "s" : "";
      return (
        <div style={{ marginBottom: "20px" }}>
          Are you sure you want to send the induction form to{" "}
          <strong>{count}</strong> contact{suffix}?
        </div>
      );
    default:
      return null;
  }
};

InductionMessage.propTypes = {
  status: PropTypes.oneOf(Object.values(INDUCTION_MESSAGE_STATUS)).isRequired,
  name: PropTypes.string,
  count: PropTypes.number
};

export default InductionMessage;
